<div class="card" *ngIf="userCompanyInfo && userDashboardInfo">
  <div class="card-header pb-0">
    <div class="category-text">
      {{ 'BUDGET.TITLE' | translate }}
    </div>
    <div class="horizontal-divider"></div>
  </div>
  <div class="card-body m-0">
    <div [ngClass]="!userCompanyInfo.hasTransportBudget && !userCompanyInfo.hasProfessionalDevelopmentBudget ? 'space-between fs-12 pb-0' : 'space-between fs-12 pb-1'">
      <div class="icon-text-container">
        <i [data-feather]="'box'" [size]="12"></i>
        <div class="font-semibold">
          {{ 'BUDGET.STANDARD' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{userDashboardInfo?.monthlyBudget}} {{'DASHBOARD.UNIT' | translate}}
      </div>
    </div>
    <div *ngIf="userCompanyInfo?.hasTransportBudget" class="space-between fs-12 pb-1">
      <div class="icon-text-container">
        <i class="bi bi-fuel-pump" style="padding-left: 1px;"></i>
        <div class="font-semibold" style="margin-left: -1px;">
          {{ 'BUDGET.TRANSPORT' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{userDashboardInfo?.monthlyBudgetTransport ? userDashboardInfo?.monthlyBudgetTransport : manualLoadTransport}} {{'DASHBOARD.UNIT' | translate}}
      </div>
    </div>
    <div *ngIf="userCompanyInfo?.hasProfessionalDevelopmentBudget" class="space-between fs-12">
      <div class="icon-text-container">
        <i [data-feather]="'monitor'" [size]="12"></i>
        <div class="font-semibold">
          {{ 'BUDGET.PROFESSIONAL_DEVELOPMENT' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{userDashboardInfo?.monthlyBudgetProfessionalDevelopment ? userDashboardInfo?.monthlyBudgetProfessionalDevelopment : manualLoadProfessionalDevelopment}} {{'DASHBOARD.UNIT' | translate}}
      </div>
    </div>
    <div class="horizontal-divider"></div>
    <div class="space-between fs-12 pb-1">
      <div class="icon-text-container">
        <i [data-feather]="'refresh-cw'"></i>
        <div class="font-semibold">
          {{ 'BUDGET.FREQUENCY' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{ 'BUDGET.LOAD_FREQUENCY_MONTH' | translate }}
      </div>
    </div>
    <div class="space-between fs-12 pb-1">
      <div class="icon-text-container">
        <i [data-feather]="'calendar'"></i>
        <div class="font-semibold">
          {{ 'BUDGET.LOAD_DATE' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{ userCompanyInfo.balanceLoadDay | ordinal: 'feminine' | titlecase }} {{ (userCompanyInfo.loadDayType == 0 ? 'BUDGET.DAY_OF_MONTH' : 'BUDGET.WORKING_DAY_OF_MONTH') | translate}}
      </div>
    </div>
    <div class="space-between fs-12">
      <div class="icon-text-container">
        <i [data-feather]="'clock'"></i>
        <div class="font-semibold">
          {{ 'BUDGET.AVAILABILITY_DATE' | translate }}
        </div>
      </div>
      <div class="font-bold">
        {{ userCompanyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed ? userCompanyInfo.budgetAvailabilityInDays : (userCompanyInfo.actualBalanceLoadDay + userCompanyInfo.budgetAvailabilityInDays) - 1}} {{'BUDGET.OF_MONTH' | translate}}
      </div>
    </div>
  </div>
</div>
